import { makeRequests } from "..";

export const getArticle = (id) => makeRequests('get', `pages/${id}/?format=json`)